import { createTheme } from '@material-ui/core';

export const grey1 = '#FBF5EE';
export const grey2 = '#F3F1EE';
export const grey3 = '#AFACA8';

export const blue0 = '#dbf5ff';
export const blue1 = '#00A0DF';
export const blue2 = '#2080F8';
export const blue3 = '#496A9F';
export const blue4 = '#1B3168';

export const green1 = '#00B090';
export const green2 = '#52ADB4';
export const green3 = '#C1EDEA';
export const green4 = '#00615a';

export const red1 = '#EC6B6D';
export const red2 = '#ECDFE0';
export const yellow1 = '#FCCB68';
export const orange1 = '#E69A40';
export const white = '#FFF';

const theme = createTheme({
    palette: {
        primary: {
            main: green1,
            contrastText: white,
        },
        secondary: {
            main: blue4,
        },
        error: {
            main: red1,
        },
    },
    colors: {
        grey1,
        grey2,
        grey3,
        blue0,
        blue1,
        blue2,
        blue3,
        blue4,
        green1,
        green2,
        green3,
        red1,
        red2,
        yellow1,
        orange1,
    },
    borders: {
        normal: `1px solid ${grey2}`,
        blue: `2px solid ${blue4}`,
        green: `2px solid ${green1}`,
        red: `1px solid ${red1}`,
        dashed: `2px dashed ${green1}`,
        boxShadow1: '2px 2px 4px 1px rgba(120, 120, 120, 0.4)',
    },
    sizes: {
        headerHeight: 80,
        footerHeight: 220,
        reducedH5FontSize: '1.25rem',
        largeIcon: '3rem',
        mediumIcon: '2.5rem',
        largeAvatar: '28px',
    },
    overrides: {
        MuiFormLabel: {
            root: {
                color: blue4,
            },
        },
        MuiTypography: {
            h3: {
                color: blue4,
            },
            h4: {
                color: blue4,
            },
            h5: {
                color: blue4,
            },
            h6: {
                color: blue4,
            },
            body1: {
                color: blue4,
            },
            body2: {
                color: blue4,
            },
            caption: {
                color: blue4,
            },
            subtitle1: {
                color: blue4,
            },
            subtitle2: {
                color: blue4,
            },
        },
    },
});

export default theme;
